<template>
    <v-card elevation="0">
        <v-card-title class="text-h6 text-uppercase">
            Персональная информация
        </v-card-title>
        <v-card-text class="text-h6">
            Вам необходимо проверить ваши персональные данные, указать пол и текущий номер телефона на момент подачи заявления.
            Остальные данные для изменения или ввода неактивны, так как они извлекаются из общей информационной базы, где хранится ваша персональная информация,
            заполненная в момент поступления в вуз или измененная в период обучения. Если вы заметили ошибку или неточность данных, то на первом шаге необходимо
            убедиться в том, что актуальная информация о вас хранится в информационной базе университета. Для этого обратитесь в деканат, к которому вы относитесь,
            запросите и уточните информацию о вас. Если после выполнения первого шага проблема не была решена, обратитесь за помощью непосредственно к разработчикам системы.
        </v-card-text>
        <v-card-title class="text-h6 text-uppercase">
            Выбор места
        </v-card-title>
        <v-card-text class="text-h6">
            Вам предоставляется возможность выбрать до трех комнат для рассмотрения в целях заселения. Приоритет выбора комнат определяется порядком, установленным вами.
            Таким образом, первая выбранная комната считается наивысшим приоритетом, и с учетом последующих комнат приоритет постепенно снижается.
            Ваши выбранные комнаты рассматриваются как предпочтения и принимаются во внимание комиссией. Однако существует возможность, что вас могут
            разместить в комнату, которую вы не выбирали.
        </v-card-text>
        <v-card-title class="text-h6 text-uppercase">
            Остальное
        </v-card-title>
        <v-card-text class="text-h6">
            Поданное заявление можно удалять и редактировать, но если после его подачи хотя бы один из участников комиссии начнет рассматривать ваше заявление,
            то удаление и редактирование станут невозможными. При рассмотрении заявления учитывается рейтинг академической успеваемости,
            отличительный признак и время подачи.
        </v-card-text>
        <v-card-actions>
            <v-btn
                    block
                    outlined
                    rounded
                    color="teal darken-1"
                    @click="NextTab"
            >
                Понятно
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {mapActions, mapMutations} from "vuex";
    import StatementHostelPDF from "../../../../../makepdfs/statement_hostel/statement_hostel_pdf";

    export default {
        name: "GeneralInfo",
        methods: {
            ...mapMutations({
            }),
            ...mapActions({
                NextTab: 'interactionStatement/NextTab',
            }),
        },
    }
</script>

<style scoped>

</style>